import { render, staticRenderFns } from "./CustomerDemoForm.vue?vue&type=template&id=171b4b81"
import script from "./CustomerDemoForm.vue?vue&type=script&lang=js"
export * from "./CustomerDemoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports